import { salesReportTemplate } from './templates/sales-report';
import { dailyCashReportTemplate } from './templates/daily-cash-report';
import { paymentReportTemplate } from './templates/payment-report';
import { revenueReportTemplate } from './templates/revenue-report';
import { foreeReportTemplate } from './templates/foree-report';

export type PDFOrientation = 'portrait' | 'landscape';

export type PDFTemplateKey = 'sales-report' | 'daily-cash-report' | 'payment-report' | 'foree-report' | 'revenue-report';

export interface PDFDateRange {
  start_date?: string;
  end_date?: string;
}

export interface PDFSummary {
  totalSales?: number;
  totalRefunds?: number;
  totalTax?: number;
  netAmount?: number;
  filteredCount?: number;
  totalCount?: number;
  payment_methods?: Record<string, number>;
  // Allow templates to extend without breaking callers
  [key: string]: unknown;
}

export interface BasePDFOptions<TData> {
  data: TData;
  filename?: string;
  title?: string;
  orientation?: PDFOrientation;
  dateRange?: PDFDateRange;
  summary?: PDFSummary;
}

type TemplateExecutor<TData> = (options: BasePDFOptions<TData>) => Promise<void>;

const templateRegistry: Record<PDFTemplateKey, TemplateExecutor<any>> = {
  'sales-report': salesReportTemplate as TemplateExecutor<any>,
  'daily-cash-report': dailyCashReportTemplate as TemplateExecutor<any>,
  'payment-report': paymentReportTemplate as TemplateExecutor<any>,
  'foree-report': foreeReportTemplate as TemplateExecutor<any>,
  'revenue-report': revenueReportTemplate as TemplateExecutor<any>,
};

export async function exportPDF<TData>(
  template: PDFTemplateKey,
  options: BasePDFOptions<TData>
): Promise<void> {
  const executor = templateRegistry[template];
  if (!executor) {
    throw new Error(`Unknown PDF template: ${template}`);
  }
  return executor(options);
}


